import type { StateCreator } from 'zustand';

import {
  getConsultationField,
  getConsultationFields,
  resetAllConsultations,
  resetConsultation,
  setConsultationField,
} from './actions';
import type { ConsultationsSliceType } from './types';

export const consultationsSlice: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType
> = (set, get, store) => ({
  // State
  consultations: {},

  // Actions
  setConsultationField: (consultationId, fieldName, value) =>
    setConsultationField(set, get, store)(consultationId, fieldName, value),
  getConsultationField: (consultationId, fieldName) => getConsultationField(set, get, store)(consultationId, fieldName),
  getConsultationFields: (consultationId) => getConsultationFields(set, get, store)(consultationId),
  resetConsultation: (consultationId) => resetConsultation(set, get, store)(consultationId),
  resetAllConsultations: () => resetAllConsultations(set, get, store)(),
});

export * from './actions';
export * from './constants';
export * from './types';
